
<template>
  <div class="expand">
    <div class="expand-title">机会匹配</div>

    <Table border :columns="columns" :data="data1">
      <template slot-scope="{ row }" slot="logo">
        <img :src="row.logo" width="28" height="28" />
      </template>
      <template slot-scope="{ row }" slot="name">{{ row.name }}</template>
      <template slot-scope="{ row }" slot="contact">{{ row.contact }}</template>
      <template slot-scope="{ row }" slot="phone">{{ row.phone }}</template>
      <template slot-scope="{ row }" slot="histroy">{{ row.histroy }}</template>
      <template slot-scope="{ row }" slot="rate">
        <Rate v-model="row.rate" disabled style="font-size: 18px;color: #1890ff;"/>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.status === 0" style="color: #fe781d;">确认中</span>
        <span v-if="row.status === 1" style="color: #ff0000;">不考虑</span>
        <span v-if="row.status === 2" style="color: #1890ff;">已接受</span>
        <span v-if="row.status === 3" style="color: #1890ff;">已合作</span>
        <span v-if="row.status === 4" style="color: #595959;">未合作</span>
      </template>
      <template slot-scope="{ row }" slot="edit">  
          <template v-if="row.status === 0">
                <span style="color: #1890ff;cursor: pointer;">接受推荐</span>
                <span style="display: inline-block;padding: 0 5px;">|</span> 
                <span style="color: #1890ff;cursor: pointer;">不考虑</span>
          </template>
          <template v-if="row.status === 1">
                <span style="color: #1890ff;cursor: pointer;">反馈</span> 
          </template>
          <template v-if="row.status === 2">
                <span style="color: #1890ff;cursor: pointer;">达成合作</span> 
          </template>
          <template v-if="row.status === 3">
                <span style="color: #1890ff;cursor: pointer;">评价</span> 
          </template>
          <template v-if="row.status === 4">
                <span style="color: #1890ff;cursor: pointer;">反馈</span> 
          </template>
        </Poptip>
      </template>
    </Table>
    <div style="padding: 10px 0">对接客服：张三 联系电话：17012315487</div>
  </div>
</template>

<script>
export default {
  props: {
    row: Object
  },
  data() {
    return {
      columns: [
        {
          title: "logo",
          width: 70,
          slot: "logo"
        },
        {
          title: "服务商名称",
          slot: "name",
            align: 'center'
        },
        {
          title: "联系人",
          slot: "contact",
            align: 'center'
        },
        {
          title: "联系方式",
          slot: "phone",
            align: 'center'
        },
        {
          title: "历史数据",
          slot: "histroy",
            align: 'center'
        },
        {
          title: "评分",
          width: 170,
          slot: "rate",
            align: 'center'
        },
        {
          title: "状态",
          slot: "status",
            align: 'center'
        },
        {
          title: "操作",
          slot: "edit",
            align: 'center'
        }
      ],
      data1: [
        {
          logo: "https://p1.ssl.qhimg.com/bdr/1080__/t0180c0ba088d364326.webp",
          name: "阿德里服装有限公司",
          contact: "李先生",
          phone: "13122959676",
          histroy: "已完成24次交易",
          rate: 4,
          status: 1
        }
      ]
    };
  }
};
</script> 

<style scoped lang="scss">
.expand {
  &-row {
    margin-bottom: 16px;
  }
  &-title {
    margin-bottom: 15px;
  }
}
</style>